import { createContext, useContext } from "react";

const DataContext = createContext<GlobalData>({});

export const useData = () => useContext(DataContext);

export default DataContext;
